import { ColDef, ColGroupDef } from "ag-grid-community";
import { BaseColDefParams } from "ag-grid-community/dist/lib/entities/colDef";
import { ProductsSpecialPricingExtended } from "models/storeModels/ProductsSpecialPricing";
import * as datefns from "date-fns";
import { ProductsSpecialPricingExtendedWithError } from "pages/dispense/dispensePricing/DispensePricingList";
import { ZTooltip } from "components/ZTooltip";
import { ZIcon } from "components/ZIcon";
import { ZIconType } from "helpers/utility/iconMap";

export function getDispensePricingConfig(canEdit: boolean): (ColDef<ProductsSpecialPricingExtendedWithError> | ColGroupDef<ProductsSpecialPricingExtendedWithError>)[] | null {
        
    return [
                {
                    field: "productID",
                    hide: true
                },
                {
                    headerCheckboxSelectionFilteredOnly: true,
                    headerCheckboxSelection: true,
                    checkboxSelection: (params) => {
                        const anyHasError = Object.values(params.data?.hasError ?? {}).some((v) => v === true);
						return !anyHasError;
                    },
                    width: 45,
                    sortable: false,
                    filter: false,
                    suppressHeaderMenuButton: true,
                },
                {
                    headerName: "Name",
                    field: "name",
                    suppressHeaderMenuButton: true,

                    cellRendererSelector: (params) => {
                        const anyHasError = Object.values(params.data?.hasError ?? {}).some((v) => v === true);
                        const errorArray: string[]= [];
                        if (params.data?.hasError?.privateFixedPrice === true) errorArray.push("Duplicate Private Entry");
                        if (params.data?.hasError?.privateFixedPriceStart === true) errorArray.push("Invalid Private start and/or end date");
                        if (params.data?.hasError?.clubFixedPrice === true) errorArray.push("Invalid Club Price");
                        if (params.data?.hasError?.clubFixedPriceStart === true) errorArray.push("Invalid Club start and/or end date");
                        if (params.data?.hasError?.pbsFixedPrice === true) errorArray.push("Duplicate PBS Entry");
                        if (params.data?.hasError?.pbsFixedPriceStart === true) errorArray.push("Invalid PBS start and/or end date");


                        const cellRendererParams = {
                            decorator:
                                anyHasError ? (
                                    <ZTooltip
                                        tooltipClassName="tooltip-text-start"
                                        text={`This line has issues${errorArray.length > 0 ? ": \n• " + errorArray.join("\n• ") : ""}`}
                                    >
                                        <ZIcon iconClassName="me-1" icon={ZIconType.Alert} variant="danger" />
                                    </ZTooltip>
                                ) : undefined,
                            decoratorPosition: "start",
                            align: "left",
                            children: (
                                <div className="text-truncate overflow-hidden">{params.data?.name}</div>
                            ),
                        };
                        return { component: "baseCellRenderer", params: cellRendererParams };
                    },
        
                },
                {
                    headerName: "Private Price",
                    field: "privateFixedPrice",
                    cellClass: 'cursor-text moneyField',
                    editable: canEdit ? true : false,
                    suppressHeaderMenuButton: true,
                    valueSetter: (params) => {
                        params.data.privateFixedPrice = params.newValue;
                        return true;
                    },
                    cellEditor: 'moneyCellEditor',
                   
                    cellRendererSelector: (_) => {
                        return { component: "editablePriceCellRenderer" }
                    }
                },
                {
                    headerName: "Qty",
                    field: "privateFixedPricePacks",
                    cellEditor: "agNumberCellEditor",
                    suppressHeaderMenuButton: true,
                    editable: canEdit ? true : false,
                },
                {
                    headerName: "Start Date",
                    field: "privateFixedPriceStart",
                    cellEditor: "agDateCellEditor",
                    cellRenderer: "baseCellRenderer",
                    suppressHeaderMenuButton: true,
                    editable: canEdit ? true : false,
                    cellEditorParams: {
                        
                    },
                    cellRendererParams: (params: BaseColDefParams<ProductsSpecialPricingExtended>) => {
                    /**        if (params.data.hasError!["startDate"] === true) {
                            return {
                                decorators: [
                                        {
                                            decorator: <ZTooltip text="Start date cannot be after end date"><ZIcon icon={ZIconType.Alert} variant="danger" /></ZTooltip>,
                                            position: "start",
                                        },
                                    ],
                                };
                        }*/
                    },
                    valueGetter: (params) => (params.data?.privateFixedPriceStart == null ? null : new Date(params.data.privateFixedPriceStart)),
                    valueFormatter: (params) => (params.value ? datefns.format(new Date(params.value), "dd/MM/yyyy") : ""), 
                  
                },
                {
                    headerName: "End Date",
                    field: "privateFixedPriceEnd",
                    cellEditor: "agDateCellEditor",
                    cellRenderer: "baseCellRenderer",
                    editable: canEdit ? true : false,
                    cellEditorParams: {
                        
                    },
                    suppressHeaderMenuButton: true,
                    cellRendererParams: (params: BaseColDefParams<ProductsSpecialPricingExtended>) => {
                    /**        if (params.data.hasError!["startDate"] === true) {
                            return {
                                decorators: [
                                        {
                                            decorator: <ZTooltip text="Start date cannot be after end date"><ZIcon icon={ZIconType.Alert} variant="danger" /></ZTooltip>,
                                            position: "start",
                                        },
                                    ],
                                };
                        }*/
                    },
                    valueGetter: (params) => (params.data?.privateFixedPriceEnd == null ? null : new Date(params.data.privateFixedPriceEnd)),
                    valueFormatter: (params) => (params.value ? datefns.format(new Date(params.value), "dd/MM/yyyy") : ""),  
                },
                {
                    headerName: "PBS Price",
                    field: "pbsFixedPrice",
                    cellClass: 'cursor-text moneyField',
                    valueSetter: (params) => {
                        params.data.pbsFixedPrice = params.newValue
                        return true;
                    },
                    cellEditor: 'moneyCellEditor',
                    editable: canEdit ? true : false,
                    suppressHeaderMenuButton: true,
                    cellRendererSelector: (_) => {
                        return { component: "editablePriceCellRenderer" }
                    }
                },
                {
                    headerName: "Qty",
                    field: "pbsFixedPricePacks",
                    cellEditor: "agNumberCellEditor",
                    suppressHeaderMenuButton: true,
                    editable: canEdit ? true : false,
                },
                {
                    headerName: "Start Date",
                    field: "pbsFixedPriceStart",
                    cellEditor: "agDateCellEditor",
                    cellRenderer: "baseCellRenderer",
                    editable: canEdit ? true : false,
                    suppressHeaderMenuButton: true,
                    cellEditorParams: {
                        
                    },
                    cellRendererParams: (params: BaseColDefParams<ProductsSpecialPricingExtended>) => {
                    /**        if (params.data.hasError!["startDate"] === true) {
                            return {
                                decorators: [
                                        {
                                            decorator: <ZTooltip text="Start date cannot be after end date"><ZIcon icon={ZIconType.Alert} variant="danger" /></ZTooltip>,
                                            position: "start",
                                        },
                                    ],
                                };
                        }*/
                    },
                    valueGetter: (params) => (params.data?.pbsFixedPriceStart == null ? null : new Date(params.data.pbsFixedPriceStart)),
                    valueFormatter: (params) => (params.value ? datefns.format(new Date(params.value), "dd/MM/yyyy") : ""),  
                },
                {
                    headerName: "End Date",
                    field: "pbsFixedPriceEnd",
                    cellEditor: "agDateCellEditor",
                    cellRenderer: "baseCellRenderer",
                    editable: canEdit ? true : false,
                    suppressHeaderMenuButton: true,
                    cellEditorParams: {
                        
                    },
                    cellRendererParams: (params: BaseColDefParams<ProductsSpecialPricingExtended>) => {
                    /**        if (params.data.hasError!["startDate"] === true) {
                            return {
                                decorators: [
                                        {
                                            decorator: <ZTooltip text="Start date cannot be after end date"><ZIcon icon={ZIconType.Alert} variant="danger" /></ZTooltip>,
                                            position: "start",
                                        },
                                    ],
                                };
                        }*/
                    },
                    valueGetter: (params) => (params.data?.pbsFixedPriceEnd == null ? null : new Date(params.data.pbsFixedPriceEnd)),
                    valueFormatter: (params) => (params.value ? datefns.format(new Date(params.value), "dd/MM/yyyy") : ""),  
                },
                {
                    headerName: "Club Price",
                    field: "clubFixedPrice",
                    cellClass: 'cursor-text moneyField',
                    suppressHeaderMenuButton: true,
                    valueSetter: (params) => {
                        params.data.clubFixedPrice = params.newValue;
                        return true;
                    },
                    cellEditor: 'moneyCellEditor',
                    editable: canEdit ? true : false,
                    cellRendererSelector: (_) => {
                        return { component: "editablePriceCellRenderer" }
                    }

                },
                {
                    headerName: "Qty",
                    field: "clubFixedPricePacks",
                    cellEditor: "agNumberCellEditor",
                    editable: canEdit ? true : false,
                    suppressHeaderMenuButton: true,
                },
                {
                    headerName: "Start Date",
                    field: "clubFixedPriceStart",
                    cellRenderer: "baseCellRenderer",
                    cellEditor: "agDateCellEditor",
                    editable: canEdit ? true : false,
                    suppressHeaderMenuButton: true,
                    cellEditorParams: {
                        
                    },
                    cellRendererParams: (params: BaseColDefParams<ProductsSpecialPricingExtended>) => {
                    /**        if (params.data.hasError!["startDate"] === true) {
                            return {
                                decorators: [
                                        {
                                            decorator: <ZTooltip text="Start date cannot be after end date"><ZIcon icon={ZIconType.Alert} variant="danger" /></ZTooltip>,
                                            position: "start",
                                        },
                                    ],
                                };
                        }*/
                    },
                    valueGetter: (params) => (params.data?.clubFixedPriceStart == null ? null : new Date(params.data.clubFixedPriceStart)),
                    valueFormatter: (params) => (params.value ? datefns.format(new Date(params.value), "dd/MM/yyyy") : ""),                  
                },
                {
                    headerName: "End Date",
                    field: "clubFixedPriceEnd",
                    cellRenderer: "baseCellRenderer",
                    cellEditor: "agDateCellEditor",
                    editable: canEdit ? true : false,
                    suppressHeaderMenuButton: true,
                    cellEditorParams: {
                        
                    },
                    cellRendererParams: (params: BaseColDefParams<ProductsSpecialPricingExtended>) => {
                    /**        if (params.data.hasError!["startDate"] === true) {
                            return {
                                decorators: [
                                        {
                                            decorator: <ZTooltip text="Start date cannot be after end date"><ZIcon icon={ZIconType.Alert} variant="danger" /></ZTooltip>,
                                            position: "start",
                                        },
                                    ],
                                };
                        }*/
                    },
                    valueGetter: (params) => (params.data?.clubFixedPriceEnd == null ? null : new Date(params.data.clubFixedPriceEnd)),
                    valueFormatter: (params) => (params.value ? datefns.format(new Date(params.value), "dd/MM/yyyy") : ""),
                },
    ]
}